import React from 'react';

/** Section wrapper with title */
export function HistorySection({ title, isDark, children }) {
  return (
    <div style={{ marginBottom: '0.75rem' }}>
      <div style={{
        fontSize: '0.625rem', fontWeight: 700, textTransform: 'uppercase',
        letterSpacing: '0.05em',
        color: isDark ? '#6b7280' : '#9ca3af',
        marginBottom: '0.375rem', marginTop: '0.5rem',
      }}>
        {title}
      </div>
      {children}
    </div>
  );
}
